import moment from "moment";
import _ from "lodash";
import {
  getItemUnitsList,
  handleUnitDropdown,
  getScaleList,
  isContributedItem,
  detectItemChanged,
  convertHHMMForDisplay,
  convertHHMMForBackend,
} from '../lib/helper';
import {
  getFailed,
  getStarted,
  getSucceeded,
  getEnded,
  GET_EDIT_SYMPTOM_USERS,
  EDIT_SYMPTOM_OPTION_SELECTED,
  EDIT_SYMPTOM_CATEGORY_SELECTED,
  SYMPTOM_SELECTED,
  EDIT_PAGE_SEARCH_SYMPTOM_OPTIONS,
  SYMPTOM_DATE_RANGE_CHANGED,
  GET_SYMPTOM_LIST,
  SYMPTOM_DELETED,
  EDIT_SYMPTOM_DATE_CHANGED,
  SYMPTOM_UNITS_NEW,
  ACTIVITY_UNITS,
  PCP_UNITS,
  DRUG_UNITS,
  SUP_UNITS,
  FOOD_UNITS,
  LOC_UNITS,
  UPDATE_SYMPTOM,
  ON_CHANGE_SYMPTOMEDITFORM,
  ON_CHANGE_SEARCHFORM,
  SYMPTOM_SEARCH_DATE_CHANGED,
  RESET_EDIT_PAGE,
  ON_SAVE_PAGE_SYMPTOMEDITFORM,
  EDITSYMPTOM_CHANGER_SEARCHFORM,
  SYMPTOM_EXPORT,
  EDITSYMPTOM_BODYMAP_RETURN,
  EDITSYMPTOM_BODYMAP_START,
  IS_UNSAVED,
  EDITSYMPTOM_EXPORT_DATE_CHANGED,
  EDIT_PAGE_BARCODE_READ,
  EDIT_PAGE_BARCODE_READ_IMG,
  PARTIAL_RESULT_FOUND,
  CLEAR_EDIT_SYMPTOMS,
  ON_CHANGE_ALERT_STATUS,
  ADD_GREY_UPC_ITEM_NAME_FIELD,
  SET_HHMM_MODE,
  RESET_CONTRIBUTE_ALERT_STATE,
  DISMISS_EDIT_SAVE_SUCCESS,
  RESET_MODAL,
} from "../actions/constant";
import i18n from "../i18n";

const initialState = {
  isLoading: false,
  users: [],
  nameOptions: [],
  nameTotalOptions: [],
  selectedCategory: "",
  disabled: {
    input: true,
    time_range: true,
    scale: true,
  },
  symptoms: [],
  scaleOptions: [],
  categories: [{ value: "00", label: i18n.t("forum.ALL_PLACEHOLDER") }],
  symptomEditForm: {},
  unitOptions: [],
  searchForm: {
    category: "00",
    start: moment().startOf("day").add(-1, "days"),
    exportStart: moment().startOf("day").add(-1, "days"),
    to: "2",
  },
  disabled: {
    start: false,
    to: false,
    searchBtn: false,
    name: true,
    scale: true,
    unit: true,
    time: true,
    comment: true,
    addBtn: true,
    saveBtn: true,
    clearBtn: true,
  },
  deleteMode: true,
  updateMode: false,
  amountReseter: false,
  amounNewValue: null,
  selectedIndex: -1,
  updatedList: false,
  counterState: 0,
  searchMode: true,
  ListOfWhile: [
    { value: "1", label: "1" },
    { value: "2", label: "2" },
    { value: "3", label: "3" },
    { value: "4", label: "4" },
    { value: "5", label: "5" },
    { value: "6", label: "6" },
    { value: "7", label: "7" },
  ],
  selectedDate: "",
  cancelMode: false,
  itemChanged: false,
  upc404: false,
  upc404Value: "",
  barcodeScanned: false,
  barcodeCategory: false,
  barcodeRead: false,
  duplicateItem: false,
  duplicateUnit: false,
  partialResult: [],
  customRecipeHasRefDbItem: false,
  barcodeValue: "",
  addCustomAlert: false,
  hhmmMode: false,
  NewTrendFound: false,
  saveSuccess: false,
  saveError: {
    type: null,
    meta: [],
  },
};

function reducer(state = initialState, action) {

  function isZeroEquivalent(scale) {
    if (!scale || typeof scale !== "string") return true; // covers "", null, undefined

    const trimmed = scale.trim();

    // Zero equivalent HH:MM format
    const isZeroTimeFormat = /^0{1,2};0{1,2}$/.test(trimmed);
    if (isZeroTimeFormat) return true;

    // Matches 0, 0., 0.0, 000, 000.000, 0/2 etc. but NOT 0 0, 0/ or 0&1
    // const zeroEquivalentPattern = /^(?:[0.]*0+(?:\s*\/\s*[1-9]\d*)?|(?:[0.]*0+\s*(?:[& ]+\s*0+)+\s*\/\s*[1-9]\d*))$/;
    const zeroEquivalentPattern = /^(?:0*\.?0*\.?|0*(?:[& ]+0+)*\s*\/\s*[1-9]\d*)$/
    return zeroEquivalentPattern.test(trimmed);
  }

  function buttonsChecker() {
    // ---------- helpers ----------
    const str = (v) => (v == null ? "" : String(v));
    const isFilled = (v) => str(v).trim().length > 0;
    const notNullStr = (v) => isFilled(v) && str(v) !== "null";

    // ---------- read state ----------
    const form   = state.symptomEditForm || {};
    const search = state.searchForm || {};
    const selected = state.selectedIndex >= 0;

    const cat = form.category;                   // for edit fields (not search panel)
    const isSymptomCat = cat === "01";

    const fullnameFilled = isFilled(form.fullname);
    const scaleRaw = form.scale;
    const unitFilled = notNullStr(form.unit);
    const timeFilled = !!form.time;

    // scale required rule:
    // - cat "01": zero allowed (counts as filled) → only need non-empty (any value)
    // - others  : zero not allowed → must be non-empty AND not zero-equivalent
    const scalePresent = isFilled(scaleRaw);
    const scaleFilledForAdd = isSymptomCat
      ? scalePresent
      : (scalePresent && !isZeroEquivalent(scaleRaw));

    // Item change for Add/Update: you maintain this elsewhere
    const itemChanged = !!state.itemChanged;

    // ---------- defaults ----------
    state.disabled.addBtn = true;


    // Save button: enabled iff updatedList truthy (exactly as you requested)
    state.disabled.saveBtn = !state.updatedList;

    // ---------- search panel enables ----------
    const searchCatValid = search.category && search.category !== "null";
    const searchBaseReady = !!search.user && !!searchCatValid;

    state.disabled.start = !searchBaseReady;
    state.disabled.to    = !searchBaseReady;

    const searchReady = searchBaseReady && !!search.start && !!search.to && search.to !== "null";
    state.disabled.searchBtn = !searchReady;

    // ---------- unit field enablement ----------
    // Source of truth: unitOptions
    const unitOptions = state.unitOptions || state.unitOption || [];
    const multiUnit = Array.isArray(unitOptions) ? unitOptions.length > 1 : false;

    // ---------- when an item is selected ----------
    if (selected) {
      // Base field enables for editing a row
      state.disabled.name    = false;
      state.disabled.scale   = false;
      state.disabled.comment = false;  // comment-only changes DO enable Add/Update
      state.disabled.time    = false;

      // Unit enablement rule:
      //  - if only 0/1 options ⇒ disable
      //  - if >1 options ⇒ enable only after name is filled
      state.disabled.unit = !multiUnit || !fullnameFilled ? true : false;

      // Add/Update gating:
      // Required fields: fullname, scale (per category rule), unit (not "null"), time
      // Note: even if unit field is disabled visually (<=1 option), we still require a non-"null" value.
      const requiredFilled =
        fullnameFilled &&
        scaleFilledForAdd &&
        unitFilled &&
        timeFilled;

      // Add is single source of truth; Update/Cancel follow
      const addEnabled = itemChanged && requiredFilled;
      state.disabled.addBtn = !addEnabled;

      state.updateMode = addEnabled;     // show "update" affordance when we could add
      state.cancelMode =
        (!itemChanged) ||                      // Case 1: no changes
        (itemChanged && !requiredFilled);      // Case 2: changes but incomplete
    } else {
      // No selection: all edit fields disabled; cannot add/update
      state.disabled.name    = true;
      state.disabled.scale   = true;
      state.disabled.unit    = true;
      state.disabled.time    = true;
      state.disabled.comment = true;
      state.disabled.addBtn  = true;

      state.updateMode = false;
      state.cancelMode = false;
    }

    // ---------- name-driven enables (extra safety, mirrors your old UX) ----------
    // If name is empty, keep edit controls off regardless of selection/multiUnit
    if (!fullnameFilled) {
      state.disabled.unit    = true;
      state.disabled.scale   = true;
      state.disabled.comment = true;
      state.disabled.time    = true;
    } else {
      // If name filled and >1 unit options, allow unit edit
      if (multiUnit) state.disabled.unit = false;
    }

    // ---------- unsaved prompt side-effect ----------
    if (!state.disabled.saveBtn) {
      IS_UNSAVED("yes");
      const logOutPrompt = {
        page: "edit",
        title: i18n.t("general.UNSAVED_DATA_LOGOUT_TITLE"),
        text: i18n.t("editsymptoms.UNSAVED_EDIT_PAGE_TEXT"),
      };
      localStorage.setItem("unsavedAlertData", JSON.stringify(logOutPrompt));
    } else {
      IS_UNSAVED("no");
    }

    state.counterState = (state.counterState || 0) + 1;
  }

  switch (action.type) {
    case getStarted(GET_EDIT_SYMPTOM_USERS):
      state.selectedCategory = "";
      return {
        ...state,
        isLoading: true,
        customRecipeHasRefDbItem: false,
        categories: [{ value: "00", label: i18n.t("forum.ALL_PLACEHOLDER") }],
      };
    case getSucceeded(GET_EDIT_SYMPTOM_USERS):
      let user_list = [action.payload.users];
      if (action.payload.users.sub_users)
        user_list = [action.payload.users, ...action.payload.users.sub_users];
      let data = user_list.map(function (e, index) {
        return {
          label: e.first_name + " " + e.last_name,
          value: e._id,
        };
      });
      let searchForm = state.searchForm;
      searchForm.user = data[0].value;
      data = _.orderBy(data, [(user) => user.label.toLowerCase()], ["asc"]);
      state.selectedDate =
        moment(state.searchForm.start).startOf("day").unix() * 1000;

      let defaultData = localStorage.getItem("contDefault");
      let defaultVal = JSON.parse(defaultData);
      let buttonStatus;

      if (defaultVal) {
        state.symptoms = defaultVal.symptoms;
        state.symptomEditForm.category = defaultVal.category,
          state.searchForm = defaultVal.searchForm;
        state.searchForm.start = defaultVal.searchForm.start ? moment(defaultVal.searchForm.start) : moment();
        state.searchForm.exportStart = defaultVal.searchForm.exportStart ? moment(defaultVal.searchForm.exportStart) : moment();
        state.contDefault = defaultVal.contDefault;
        state.symptomEditForm = defaultVal.symptomEditForm;
        state.selectedIndex = defaultVal.selectedIndex;
        state.itemSelected = defaultVal.itemSelected;
        state.symptomEditForm.name = defaultVal.name ? defaultVal.name : defaultVal.fullname;
        state.symptomEditForm.fullname = defaultVal.fullname ? defaultVal.fullname : defaultVal.name;
        state.symptomEditForm.displayname = defaultVal.name ? defaultVal.name : defaultVal.fullname;
        state.symptomEditForm.upc = defaultVal.upc;
        state.searchMode = defaultVal.searchMode;
        state.symptomEditForm.time = defaultVal.defaultDate !== "" ? moment(defaultVal.defaultDate) : moment();
        state.symptomEditForm.scale = defaultVal.itemSelected.scale;
        state.symptomEditForm.unit = "";
        state.symptomEditForm.category = !defaultVal.category ? defaultVal.itemSelected.category : defaultVal.category;
        state.unitOptions = defaultVal.unitOptions;
        buttonStatus = defaultVal.buttonStatus;
        defaultVal = {};
      }
      if (state.itemSelected && state.itemSelected.category) {
        state.selectedCategory = state.itemSelected.category;
      }

      state.updatedList = buttonStatus
        ? buttonStatus.updatedList
        : state.update;

      buttonsChecker();
      if (state.symptomEditForm && state.symptomEditForm.fullname && state.symptomEditForm.fullname != "") {
        state.disabled.unit = state.symptomEditForm && state.symptomEditForm.fullname != "" ? false : true;
        state.disabled.scale = state.symptomEditForm && state.symptomEditForm.fullname != "" ? false : true;
        state.disabled.time = state.symptomEditForm && state.symptomEditForm.fullname != "" ? false : true;
        state.disabled.name = state.symptomEditForm && state.symptomEditForm.upc != "" ? false : true;
        state.disabled.comment = state.symptomEditForm && state.symptomEditForm.upc != "" ? false : true;
      }
      state.amountReseter = !state.amountReseter;
      if (!localStorage.getItem("unContributed")) {
        localStorage.removeItem("contDefault");
      }

      return {
        ...state,
        isLoading: false,
        users: data,
        categories: [
          { value: "00", label: i18n.t("forum.ALL_PLACEHOLDER") },
          ...action.payload.categories,
        ],
      };

    case EDIT_SYMPTOM_CATEGORY_SELECTED:
      let disabled = state.disabled;
      state.selectedCategory = action.value;
      state.searchForm.category = action.value;
      state.amountReseter = !state.amountReseter;
      state.amounNewValue = "";
      state.selectedIndex = -1;
      state.itemSelected = {};
      state.symptoms = [];
      state.symptomEditForm = {
        category: action.value,
      };
      state.unitOptions = [];
      state.scaleOptions = [];
      state.searchMode = true;
      state.updatedList = false;
      state.updateMode = false;
      state.cancelMode = false;
      state.itemChanged = false;

      if (state.hhmmMode) {
        state.hhmmMode = false;
        state.amountReseter = !state.amountReseter;
      }

      buttonsChecker();
      return { ...state, isLoading: false };

    case SYMPTOM_SELECTED: {
      state.symptomEditFormPrevious = {}
      const idx = action.index;

      // Toggle selection in the list
      const symptoms = state.symptoms.map((row, i) => ({
        ...row,
        selected: i === idx ? !row.selected : false,
      }));

      // Deselect an item path
      if (idx === state.selectedIndex) {
        state.selectedIndex   = -1;
        state.amountReseter = !state.amountReseter;
        state.amounNewValue = "";
        state.cancelMode = false;
        state.scaleOptions = [];
        state.unitOptions = [];

        state.itemSelected    = {};
        state.symptomEditForm = {};
        state.symptomEditForm.unitOptions = [];
        state.updateMode = false;
        state.outOfRange = false;
        state.symptomEditForm.scale = "";
        state.symptomEditForm.units = "";
        state.itemChanged = false;

        // 🔧 Reset placeholder source to the page's category (e.g., "All" -> "00")
        state.selectedCategory = state.searchForm.category;

        if (state.hhmmMode) {
          state.hhmmMode = false;
          state.amountReseter = !state.amountReseter;
        }

        state.symptoms = symptoms;
        buttonsChecker();
        return { ...state };
      }

      // Select an item path
      const raw     = action.item;
      const hasUpd  = raw.status === 1;
      const cat     = String(hasUpd ? raw.updatedData.category : raw.category);

      // Row payload: Food (02) uses meals[0], others are flat
      const rowForForm = hasUpd
        ? (cat === "02" ? (raw.updatedData.meals && raw.updatedData.meals[0]) : raw.updatedData)
        : (cat === "02" ? (raw.meals && raw.meals[0]) : raw);

      // Selected id rule:
      // - Food (02): updatedData.meals[0]._id when status==1, else meals[0]._id
      // - Others   : updatedData._id when status==1, else item._id
      const selectedId = hasUpd
        ? (cat === "02" ? (raw.updatedData.meals && raw.updatedData.meals[0] && raw.updatedData.meals[0]._id) : raw.updatedData._id)
        : (cat === "02" ? (raw.meals && raw.meals[0] && raw.meals[0]._id) : raw._id);

      // Normalize helpers
      const toIdArray = (v) =>
        Array.isArray(v) ? v.map(String) : (v != null && String(v) !== "" ? [String(v)] : []);
      const normalizeOptions = (opts) =>
        (Array.isArray(opts) ? opts : []).map(o => ({ value: String(o.value), label: o.label }));

      // Pull units list & current unit from the selected row (not from state)
      const itemUnits = toIdArray(rowForForm && (rowForForm.units || rowForForm.unitList || rowForForm.unit || rowForForm.unitsid));
      const unitFromRow = String(rowForForm && (rowForForm.unitid || rowForForm.unit || "")) || "";

      // Prefer prebuilt unitOptions that GET_SYMPTOM_LIST attached to the row
      const prebuilt = normalizeOptions(rowForForm && rowForForm.unitOptions);
      const units = prebuilt.length
        ? prebuilt
        : normalizeOptions(handleUnitDropdown(cat, { unitList: itemUnits }));

      // Symptom scale options derived from the available unit IDs
      state.scaleOptions = (cat === "01")
        ? getScaleList(unitFromRow)
        : [];

      // Build the form payload
      const data = {
        time:    moment((hasUpd ? raw.updatedData.date : raw.date)),
        name:    rowForForm && (rowForForm.name || rowForForm.recipe || rowForForm.symptom_name),
        fullname:rowForForm && (rowForForm.fullname || rowForForm.recipe_full || rowForForm.symptom_name),
        displayname: rowForForm && rowForForm.displayname || "",
        symptom: rowForForm && (rowForForm.symptom || rowForForm.act_id || rowForForm.pcp_id || rowForForm.drug_id || rowForForm.item_id || rowForForm._id),
        scale:   rowForForm && (rowForForm.severity || rowForForm.size || rowForForm.value),
        unit:    unitFromRow,                 // temporary; we’ll validate/adjust below
        comment: (hasUpd ? raw.updatedData.comment : raw.comment) || "",
        upc:     rowForForm && rowForForm.upc || "",
        _id:     selectedId || "",
        category:cat,
        is_custom: hasUpd ? raw.updatedData.is_custom : raw.is_custom,
        ingredients_text: rowForForm && rowForForm.ingredients_text,
      };

      // If the selected unit is not present in options:
      // - If exactly one option, auto-select it
      // - Else leave blank (do NOT force 142 here)
      if (!units.some(u => String(u.value) === String(data.unit))) {
        if (units.length === 1) {
          data.unit = String(units[0].value);
        } else {
          data.unit = "";
        }
      }

      // Write UI state
      state.symptoms        = symptoms;
      state.selectedIndex   = idx;
      state.itemSelected    = { ...data, orgItem: raw };
      state.symptomEditForm = data;

      // Mirror options to both places (truth lives on the form too)
      state.unitOptions = units;
      state.symptomEditForm.unitOptions = units;

      // Amount display sync
      state.amountReseter = !state.amountReseter;
      state.amounNewValue = data.scale;

      // 🕒 Auto-toggle HH:MM mode based on the selected item's unit (only on SELECT path)
      // If user deselected above, selectedIndex == -1 and we already flipped hhmmMode off.
      const isHHMMUnit = String(data.unit) === "445";

      if (isHHMMUnit && !state.hhmmMode) {
        state.hhmmMode = true;
        state.amountReseter = !state.amountReseter;
      } else if (!isHHMMUnit && state.hhmmMode) {
        state.hhmmMode = false;
        state.amountReseter = !state.amountReseter;
      }      

      state.selectedCategory = data.category || state.searchForm.category;
      state.updateMode   = false;
      state.itemChanged  = false;
      state.outOfRange   = false;

      buttonsChecker();
      return { ...state };
    }

    case getStarted(GET_SYMPTOM_LIST):
      return { ...state, isLoading: true };
    case getEnded(GET_SYMPTOM_LIST):
      return { ...state, isLoading: false };
    case getSucceeded(GET_SYMPTOM_LIST):
      let symptoms = action.payload;
      symptoms.map((item) => {
        item.date = moment(item.date.$numberLong * 1000).unix();
      });

      // HH;MM display + prebuild unitOptions per row (first load: no status===1)
      function toIdArray(raw) {
        if (Array.isArray(raw)) return raw.map(String);
        if (raw !== undefined && raw !== null && String(raw) !== "") return [String(raw)];
        return [];
      }

      symptoms = (Array.isArray(symptoms) ? symptoms : []).map((it, idx) => {
        const cat = String(it.category || "");

        if (cat === "02") {
          // ===== Food: use meals[0] only (fresh list, no updatedData) =====
          const meal0 = it.meals && it.meals[0] ? it.meals[0] : null;
          if (meal0) {
            // HH;MM display conversion for decimal hours ≥ 3h (unit 102)
            if (String(meal0.unitid) === "102") {
              const dispF = convertHHMMForDisplay(String(meal0.size || ""), "102");
              if (dispF.unit === "445") {
                meal0.unitid = "445";
                meal0.size   = dispF.display;
                // keep original for later use if needed
                meal0.backendUnit  = dispF.backendUnit;   // "102"
                meal0.backendScale = dispF.backendScale;  // original decimal hours string
              }
            }

            // Build unitOptions strictly from backend ids (with unitid fallback)
            let listF = toIdArray(meal0.units);                 // <-- use only `units` for Food
      
            // No 445 auto-add for Food
            meal0.unitOptions = handleUnitDropdown("02", { unitList: listF })
              .map(o => ({ value: String(o.value), label: o.label }));

          }
          return it;
        }

        // ===== Non-food categories (01/03/04/05/06/07) =====
        // HH;MM display conversion for decimal hours ≥ 3h (unit 102)
        const unitRaw = String(it.unitid !== undefined && it.unitid !== null ? it.unitid : "");
        const valRaw  = String(it.value  !== undefined && it.value  !== null ? it.value  : "");
        if (unitRaw === "102") {
          const disp = convertHHMMForDisplay(valRaw, "102");
          if (disp.unit === "445") {
            it.unitid = "445";
            it.value  = disp.display;
            it.backendUnit  = disp.backendUnit;   // "102"
            it.backendScale = disp.backendScale;  // original decimal hours string
          }
        }

        // Build unitOptions from backend ids (with unitid fallback)
        let list = toIdArray(it.units);

        // 01: DO NOT force 142 here; just reflect backend (or fallback to selected unitid)
        // 03/07: handleUnitDropdown will auto-include 445 when 102 exists
        it.unitOptions = handleUnitDropdown(cat, { unitList: list })
          .map(o => ({ value: String(o.value), label: o.label }));

        return it;
      });

      if (action.payload.length === 0) {
        symptoms = 404;
        state.searchMode = true;
      } else {
        state.searchMode = false;
      }

      // Reset UI state on fresh list
      state.selectedIndex = -1;
      state.itemSelected = {};
      state.symptomEditForm = {};
      state.symptoms = symptoms;
      state.selectedCategory = state.searchForm.category;
      state.unitOptions = [];
      state.scaleOptions = [];
      state.amountReseter = !state.amountReseter;
      state.amounNewValue = "";
      state.updatedList = false;
      state.updateMode = false;
      state.cancelMode = false;
      state.hhmmMode = false;

      if (state.symptoms && state.symptoms !== 404) {
        state.symptoms.sort((a, b) => {
            let itemA = a.updatedData ? a.updatedData.date : a.date;
            let itemB = b.updatedData ? b.updatedData.date : b.date;
            return itemA - itemB;
          }
        );
      }
      buttonsChecker();
      return { ...state, itemChanged: false };

    case EDIT_PAGE_SEARCH_SYMPTOM_OPTIONS: {
      state.partialResult = [];
      state.duplicateUnit = false;
      state.customRecipeHasRefDbItem = false;

      const contributed = isContributedItem(state.symptomEditForm) && !action.crossClicked;

      // Enable/disable scale control based on presence of text
      disabled = state.disabled;
      disabled.scale = action.val === "" ? true : false;
      state.disabled = disabled;

      // If name actually changed…
      if (state.symptomEditForm.fullname !== action.val) {
        // Preserve/clear ID depending on contributed status
        state.symptomEditForm.symptom = contributed ? state.symptomEditForm.symptom : "";

        // Clear any prefilled ingredients text on rename
        state.symptomEditForm.ingredients_text = "";

        // For non-contributed, clear unit now; for contributed we’ll decide after linking options
        if (!contributed) state.symptomEditForm.unit = "";
      }

      // Update name/display fields
      state.symptomEditForm.fullname     = action.val;
      state.symptomEditForm.name         = action.val;
      state.symptomEditForm.displayname  = action.val;

      // Keep unit list mirrors unless redirected/cleared upstream
      state.symptomEditForm.units    = (state.symptomEditForm.upc === "" || action.contributeRedirectionAlert) ? [] : state.symptomEditForm.units;
      state.symptomEditForm.unitList = (state.symptomEditForm.upc === "" || action.contributeRedirectionAlert) ? [] : state.symptomEditForm.units;

      // Clear amount on rename
      state.scaleOptions = [];
      state.amountReseter = !state.amountReseter;
      state.amounNewValue = "";
      state.symptomEditForm.scale = "";

      // Keep UPC unless explicitly changed upstream
      state.symptomEditForm.upc = state.symptomEditForm.upc;
      state.symptomEditForm.time = state.symptomEditForm.time || moment();

      // ---- Unit options + selected unit ----
      var cat = String(state.symptomEditForm.category);
      var finalOptions = [];

      if (contributed) {
        // Reuse options that came from the selected row (linked in SYMPTOM_SELECTED)
        var optsFromForm  = Array.isArray(state.symptomEditForm.unitOptions) ? state.symptomEditForm.unitOptions : [];
        var optsFromState = Array.isArray(state.unitOptions) ? state.unitOptions : [];
        var optsFromItem  = state.itemSelected && Array.isArray(state.itemSelected.unitOptions) ? state.itemSelected.unitOptions : [];

        finalOptions = optsFromForm.length ? optsFromForm : (optsFromState.length ? optsFromState : optsFromItem);

        // Decide selected unit after options are linked
        if (finalOptions.length === 1) {
          state.symptomEditForm.unit = String(finalOptions[0].value);   // keep/auto-fill single unit
        } else {
          state.symptomEditForm.unit = "";                              // force re-pick when multiple
        }
      } else {
        // Non-contributed: compute fresh per spec
        if (cat === "01") {
          finalOptions = [{ value: "142", label: i18n.t("symptoms.ITEM_UNIT_TEXT") }];
          state.symptomEditForm.unit = "142";
          state.symptomEditForm.type = "None";
        } else if (cat === "03") {
          finalOptions = handleUnitDropdown(cat, state.symptomEditForm, true); // search mode prunes 103/104
          if (finalOptions.length === 1) {
            state.symptomEditForm.unit = String(finalOptions[0].value);
          } else {
            state.symptomEditForm.unit = "";
          }
        } else {
          finalOptions = handleUnitDropdown(cat, state.symptomEditForm, true);
          state.symptomEditForm.unit = "";
        }

        // Write truth to the form
        state.symptomEditForm.unitOptions = finalOptions;
      }

      // Mirror options for the Dropdown component
      state.unitOptions = finalOptions;

      // Cross-clicked: hard reset everything regardless of contributed
      if (action.crossClicked) {
        state.symptomEditForm.upc = "";
        state.unitOptions = [];
        state.symptomEditForm.unitOptions = [];
        state.symptomEditForm.unitList = [];
        state.symptomEditForm.units = [];
        state.symptomEditForm.unit = "";
        state.symptomEditForm.unitsid = "";
        state.symptomEditForm.category = state.itemSelected.category;

        // Clear all display/name fields
        state.symptomEditForm.name = "";
        state.symptomEditForm.sName = "";
        state.symptomEditForm.recipe_full = "";
        state.symptomEditForm.recipes = "";
        state.symptomEditForm.recipe = "";
        state.symptomEditForm.full_name = "";
        state.symptomEditForm.fullname = "";
        state.symptomEditForm.displayname = "";
      }

      // If UPC 404 passthrough
      if (state.upc404 && !action.crossClicked) {
        state.symptomEditForm.upc = state.upc404Value;
      }

      if (action.contributeRedirectionAlert) {
        state.contributeRedirectionAlert = false;
        state.symptomEditForm.unit = "";
      }

      // Exit HH:MM mode on rename
      if (state.hhmmMode) {
        state.hhmmMode = false;
        state.amountReseter = !state.amountReseter; // remount input
      }

      state.symptomEditFormPrevious = {}

      buttonsChecker();
      state.itemChanged = detectItemChanged(state.symptomEditForm, state.itemSelected);

      return { ...state, upc404: false, itemInVerAutofill: false };
    }

    case SYMPTOM_DATE_RANGE_CHANGED:
      let symptomForm = state.time_range;
      symptomForm[action.key] = action.val;
      state.updatedList = false;
      state.updateMode = false;
      return { ...state, time_range: symptomForm };

    case SYMPTOM_DELETED:
      state.symptoms.forEach((item) => {
        item.selected = false;
        if (item._id == action.vId) {
          item.status = 2;
        }
      });
      state.selectedCategory = state.searchForm.category;
      state.selectedIndex = -1;
      state.itemSelected = {};
      state.symptomEditForm = {};
      state.disabled.saveBtn = false;
      state.amountReseter = !state.amountReseter;
      state.amounNewValue = "";
      state.updatedList = true;
      state.searchMode = true;
      state.unitOptions = [];
      state.scaleOptions = [];
      state.symptomEditForm.category = formCategory;
      state.itemChanged = false;

      if (state.hhmmMode) {
        state.hhmmMode = false;
        state.amountReseter = !state.amountReseter;
      }

      buttonsChecker();
      return { ...state, updateMode: false, cancelMode: false };

    case EDIT_SYMPTOM_DATE_CHANGED:
      state.symptomEditForm.time = action.val;
      // ❌ Do NOT set itemChanged = true here because if user revert time back to original, we're not handling itemchanged=false here. Forcing it to true here will lead to false positive
      // ❌ Do NOT set itemChanged = false here because there may be changes in other fields. Forcing it to false here will lead to false negative
      buttonsChecker();
      return { ...state };

    case EDIT_SYMPTOM_OPTION_SELECTED: {
      state.symptomEditFormPrevious = {}
      // --- Helpers ---
      const toIdArray = (raw) => {
        if (Array.isArray(raw)) return raw.map(String);
        if (raw !== undefined && raw !== null && String(raw) !== "") return [String(raw)];
        return [];
      };

      // --- Setup & basic text fields ---
      state.partialResult = [];
      let form = state.symptomEditForm || {};
      const cat = String(state.itemSelected && state.itemSelected.category || form.category || "");
      const it  = action.item || {};

      form = {
        ...form,
        // IDs & names
        symptom: it._id,
        fullname: it.recipe_full || it.fullname || it.name || it.title || "",
        name: it.recipe || it.name || "",
        displayname: (it.recipe || it.displayname || it.name || ""),
        // don’t touch time here (leave form.time as-is)
        ingredients_text: it.ingredients_text || "",
      };

      // --- Extract the unit id list per category payload shape ---
      let unitListIds = [];
      if (cat === "01") {
        unitListIds = toIdArray(it.unitsid);
      } else if (cat === "02") {
        unitListIds = toIdArray(it.units);
      } else if (cat === "03") {
        unitListIds = toIdArray(it.unit);      // Activity uses `unit`
      } else {
        unitListIds = toIdArray(it.units);     // 04/05/06/07
      }

      // --- Build options via helper (no search-exclusions here) ---
      const opts = handleUnitDropdown(cat, { unitList: unitListIds }, /*is_search=*/false) || [];
      const unitOptions = opts.map(o => ({ value: String(o.value), label: o.label }));

      // Mirror options everywhere (single source, two mirrors for UI)
      state.unitOptions = unitOptions;
      form.unitOptions  = unitOptions;

      // Keep raw id list on the form too
      form.units    = unitListIds;
      form.unitList = unitListIds;

      // --- Pick selected unit: only when a single concrete option remains after helper expansion ---
      if (unitOptions.length === 1) {
        form.unit = String(unitOptions[0].value);
      } else {
        form.unit = "";
      }

      form.scale = "";
      state.amounNewValue = "";
      state.amountReseter = !state.amountReseter;
      state.hhmmMode = false;

      // --- Build scaleOptions (keep current behavior for Symptom 01) ---
      let scaleOptions = [];
      if (cat === "01") {
        const symptomUnits = SYMPTOM_UNITS_NEW() || [];
        const meta = symptomUnits.find(u => String(u._id) === String(form.unit));
        if (meta) {
          if (Array.isArray(meta.label) && Array.isArray(meta.value)) {
            scaleOptions = meta.value.map((v, i) => ({ value: v, label: meta.label[i] }));
          } else if (meta.description && Array.isArray(meta.value)) {
            scaleOptions = [];
            scaleOptions.desc = meta.description;
            // preserve possible range info as you had elsewhere
            scaleOptions.min = meta.value[0];
            scaleOptions.max = meta.value[1];
          }
        }
      }
      state.scaleOptions = scaleOptions;

      // --- UPC handling (preserve your existing rule) ---
      const idPrefix = String(it._id || "").charAt(0);
      if (idPrefix !== "1" && it.upc) {
        form.upc = it.upc;
      }
      state.itemSelected = { ...(state.itemSelected || {}), upc: "" };

      // --- Final writes & flags ---
      state.symptomEditForm = form;
      state.symptomEditForm.scale = ""; // ensure clear
      state.disabled.scale = false;

      buttonsChecker();
      return { ...state, disabled: state.disabled };
    }

    case getStarted(UPDATE_SYMPTOM):
      return { ...state, isLoading: true };

    case getFailed(UPDATE_SYMPTOM):
      alert(action.payload.message);
      return { ...state, isLoading: false };

    case getSucceeded(UPDATE_SYMPTOM):
      var symptomEditForm = state.symptomEditForm;
      formCategory = symptomEditForm.category;
      symptoms = state.symptoms;

      // Preserve 0 by checking for undefined/null explicitly
      var unitRaw = (typeof action.newData.unitid !== "undefined" && action.newData.unitid !== null)
        ? action.newData.unitid
        : (typeof action.newData.unit !== "undefined" && action.newData.unit !== null)
          ? action.newData.unit
          : "";
      unitRaw = String(unitRaw);

      var scaleRaw = (typeof action.newData.scale !== "undefined" && action.newData.scale !== null)
        ? action.newData.scale
        : (typeof action.newData.value !== "undefined" && action.newData.value !== null)
          ? action.newData.value
          : (typeof action.newData.severity !== "undefined" && action.newData.severity !== null)
            ? action.newData.severity
            : "";
      scaleRaw = String(scaleRaw);

      for (let i = 0; i < symptoms.length; i++) {
        if (symptoms[i].selected) {
          // ---- 1) Build updatedData with backend fields (keep your existing logic) ----
          let updatedData;
          if (unitRaw === "445" && /[:;]/.test(scaleRaw)) {
            const conv = convertHHMMForBackend(scaleRaw, unitRaw);
            updatedData = {
              // keep all original fields
              ...action.newData,
              // add uniform backend fields
              backendUnit: conv.unit,
              backendScale: conv.scale,
            };
          } else {
            // Passthrough for non-445 or non-HH;MM, but still add backend fields
            updatedData = {
              ...action.newData,
              backendUnit: unitRaw,
              backendScale: scaleRaw,
            };
          }

          // ---- 2) Normalize unit options from the form (already computed earlier) ----
          // These must be strings to match the Dropdown comparison logic later.
          var formOpts = Array.isArray(state.symptomEditForm.unitOptions)
            ? state.symptomEditForm.unitOptions.map(function(o) {
                return { value: String(o.value), label: o.label };
              })
            : [];
          var optIds = formOpts.map(function(o){ return String(o.value); });

          // ---- 3) Attach options to updatedData (cat-aware) without recomputing ----
          var cat = String(state.symptomEditForm.category || "");

          if (cat === "02") {
            // Food rows carry units/options in meals[0]
            if (updatedData.meals && updatedData.meals[0]) {
              // Keep selected unit id as a string
              var picked = String(
                (typeof updatedData.meals[0].unitid !== "undefined" && updatedData.meals[0].unitid !== null)
                  ? updatedData.meals[0].unitid
                  : (state.symptomEditForm.unit || "")
              );

              updatedData.meals[0] = {
                ...updatedData.meals[0],
                unitid: picked,
                // Truth for later selections:
                unitOptions: formOpts,
                // Provide an id list so SYMPTOM_SELECTED can rebuild reliably
                units: Array.isArray(updatedData.meals[0].units) && updatedData.meals[0].units.length
                  ? updatedData.meals[0].units.map(String)
                  : optIds
              };
            }
          } else {
            // Non-food rows keep options at the top level
            var pickedTop = String(
              (typeof updatedData.unitid !== "undefined" && updatedData.unitid !== null)
                ? updatedData.unitid
                : (typeof updatedData.unit !== "undefined" && updatedData.unit !== null)
                  ? updatedData.unit
                  : state.symptomEditForm.unit || ""
            );

            updatedData = {
              ...updatedData,
              // Normalize the field your select path reads later
              unitid: pickedTop,
              // Truth for later selections:
              unitOptions: formOpts,
              // Provide an id list if the row didn't already have one
              units: Array.isArray(updatedData.units) && updatedData.units.length
                ? updatedData.units.map(String)
                : optIds
            };
          }

          // ---- 4) Commit updated row & flags ----
          symptoms[i].updatedData = updatedData;
          symptoms[i].selected = false;
          symptoms[i].status = 1;

          break;
        }
      }
      state.symptoms = symptoms;
      state.selectedIndex = -1;
      state.itemSelected = {};
      state.symptomEditForm = {
        //category: state.symptomEditForm.category
      };
      state.amountReseter = !state.amountReseter;
      state.amounNewValue = "";
      state.disabled.saveBtn = false;
      state.updatedList = true;
      state.scaleOptions = [];
      state.searchMode = true;
      state.updateMode = false;
      state.itemChanged = false;
      state.outOfRange = false;
      state.selectedCategory = state.searchForm.category;
      state.unitOptions = [];

      if (state.hhmmMode) {
        state.hhmmMode = false;
        state.amountReseter = !state.amountReseter;
      }

      buttonsChecker();
      return { ...state, isLoading: false };
    case ON_CHANGE_SYMPTOMEDITFORM:
      const field = action.event.target.name;
      const val   = action.event.target.value;

      // Apply change
      state.symptomEditForm[field] = val;

      if (field === "unit" || field === "scale") {
        if (state.symptomEditForm.unit != "") {
          let sunits;
          if (state.symptomEditForm.category === "01") {
            sunits = SYMPTOM_UNITS_NEW();
          } else if (state.symptomEditForm.category === "02") {
            sunits = FOOD_UNITS();
          } else if (state.symptomEditForm.category === "04") {
            sunits = PCP_UNITS();
          } else if (state.symptomEditForm.category === "05") {
            sunits = DRUG_UNITS();
          } else if (state.symptomEditForm.category === "06") {
            sunits = SUP_UNITS();
          } else if (state.symptomEditForm.category === "03") {
            sunits = ACTIVITY_UNITS();
          } else if (state.symptomEditForm.category === "07") {
            sunits = LOC_UNITS();
          }
          let scalList = [];
          for (const sunit of sunits) {
            if (state.symptomEditForm.unit === sunit._id) {
              if (sunit.label) {
                for (let index = 0; index < sunit.value.length; index++) {
                  scalList.push({
                    value: sunit.value[index],
                    label: sunit.label[index],
                  });
                }
              } else {
                if (sunit.description) {
                  scalList.desc = sunit.description;
                  scalList.min = sunit.value[0];
                  scalList.max = sunit.value[1];
                }
              }
            }
          }
          state.scaleOptions = scalList;

          // Checking for the allowed number range
          let scaleValue = state.symptomEditForm.scale.trim();
          let parsedValue = NaN;

          // Check for mixed fraction: "1 & 1/2" or "1 1/2"
          let mixedFraction = scaleValue.match(/^(\d+)\s*[& ]\s*(\d+)\/(\d+)$/);
          if (mixedFraction) {
            const whole = parseInt(mixedFraction[1], 10);
            const numerator = parseInt(mixedFraction[2], 10);
            const denominator = parseInt(mixedFraction[3], 10);
            parsedValue = whole + numerator / denominator;
          } else {
            // Check for pure fraction: "1/2"
            let simpleFraction = scaleValue.match(/^(\d+)\/(\d+)$/);
            if (simpleFraction) {
              const numerator = parseInt(simpleFraction[1], 10);
              const denominator = parseInt(simpleFraction[2], 10);
              parsedValue = numerator / denominator;
            } else {
              // Try parsing as a float (normal number)
              parsedValue = parseFloat(scaleValue);
            }
          }

          // Flag for "Value too Small or Too Large" prompt
          if (!isNaN(parsedValue) && (parsedValue < scalList.min || parsedValue > scalList.max)) {
            const cleanedNewName = (state.symptomEditForm.name || "").trim().toLowerCase().replace(/\(c\)$/i, "").trim();
            const cleanedOriginalName = (state.itemSelected.name || "").trim().toLowerCase().replace(/\(c\)$/i, "").trim();

            let hasNameChanged;
            if (state.itemSelected.symptom) {
              hasNameChanged = !state.symptomEditForm.symptom || state.itemSelected.symptom != state.symptomEditForm.symptom;
            } else if (state.itemSelected.upc) {
              hasNameChanged = !state.symptomEditForm.upc || state.itemSelected.upc !== state.symptomEditForm.upc;
            } else {
              hasNameChanged = cleanedNewName !== cleanedOriginalName;
            }

            const categoryChanged = (state.symptomEditForm.category || "").toString() !== (state.itemSelected.category || "").toString();
            const unitChanged = (state.symptomEditForm.unit || "").toString() !== (state.itemSelected.unit || "").toString();
            const scaleChanged = (state.symptomEditForm.scale || "").toString().trim() !== (state.itemSelected.scale || "").toString().trim();

            if (hasNameChanged || categoryChanged || unitChanged || scaleChanged) {

              state.outOfRange = true;
            } else {
              state.outOfRange = false;
            }
          } else {
            state.outOfRange = false;
          }
        }
      }

      const prev = state.symptomEditFormPrevious || {};
      const current = state.symptomEditForm;

      const unitChangedToNonHHMM = prev.unit === "445" && current.unit !== "445";
      const unitChangedToHHMM = prev.unit !== "445" && current.unit === "445";

      // Deactivate hhmmMode if user changes unit away from 445
      if (unitChangedToNonHHMM) {
        state.hhmmMode = false;
        state.amountReseter = !state.amountReseter;
        state.symptomEditForm.scale = "";
        state.amounNewValue = "";
      }

      // Activate hhmmMode if user manually selects 445 (HH:MM unit)
      if (unitChangedToHHMM) {
        state.hhmmMode = true;
        state.amountReseter = !state.amountReseter;
        state.symptomEditForm.scale = "";
        state.amounNewValue = "";
      }

      // ✅ Update the stored previous values at the end
      state.symptomEditFormPrevious = {
        name: current.name || "",
        category: current.category || "",
        unit: current.unit || ""
      };

      state.itemChanged = detectItemChanged(state.symptomEditForm, state.itemSelected);

      buttonsChecker();
      return { ...state };

    case ON_CHANGE_SEARCHFORM:
      let name = action.event.target
        ? action.event.target.name
        : action.event.label;
      let value = action.event.target
        ? action.event.target.value
        : action.event.value;
      state.searchForm[name] = value;
      if (name != "toExport") {
        state.amountReseter = !state.amountReseter;
        state.amounNewValue = "";
        state.selectedIndex = -1;
        state.itemSelected = {};
        state.unitOptions = [];
        state.scaleOptions = [];
        state.updatedList = false;
        state.searchMode = true;
        state.updateMode = false;
        state.cancelMode = false;
      }
      if (name == "user") {
        state.symptomEditForm = {};
        state.selectedIndex = -1;
        state.itemSelected = {};
        state.symptoms = [];
        state.unitOptions = [];
        state.scaleOptions = [];
        state.updatedList = false;
        state.searchMode = true;
        state.amountReseter = !state.amountReseter;
        state.amounNewValue = "";

        // Exit HH:MM mode on change
        if (state.hhmmMode) {
          state.hhmmMode = false;
          state.amountReseter = !state.amountReseter; // remount input
        }
      }
      if (name === "to") {
        state.symptomEditForm = {};
        state.symptoms = [];
        state.amountReseter = !state.amountReseter;
        state.amounNewValue = "";

        // Exit HH:MM mode on change
        if (state.hhmmMode) {
          state.hhmmMode = false;
          state.amountReseter = !state.amountReseter; // remount input
        }
      }
      state.itemChanged = false;
      state.amountReseter = !state.amountReseter;
      state.selectedCategory = state.searchForm.category;

      buttonsChecker();
      return { ...state };
    case SYMPTOM_SEARCH_DATE_CHANGED:
      state.searchForm.start = action.val;
      state.searchForm.exportStart = action.val;
      let formCategory = state.symptomEditForm.category;
      state.amountReseter = !state.amountReseter;
      state.amounNewValue = "";
      state.selectedIndex = -1;
      state.itemSelected = {};
      state.symptoms = [];
      state.symptomEditForm = {};
      state.unitOptions = [];
      state.scaleOptions = [];
      state.updatedList = false;
      state.itemChanged = false;
      state.updateMode = false;
      state.cancelMode = false;
      state.searchMode = true;
      state.selectedCategory = state.searchForm.category;
      state.selectedDate =
        moment(state.searchForm.start).startOf("day").unix() * 1000;

      // Exit HH:MM mode on change
      if (state.hhmmMode) {
        state.hhmmMode = false;
        state.amountReseter = !state.amountReseter; // remount input
      }

      buttonsChecker();
      return { ...state };
    case RESET_EDIT_PAGE:
      state.searchForm = {};
      state.amountReseter = !state.amountReseter;
      state.amounNewValue = "";
      state.selectedIndex = -1;
      state.itemSelected = {};
      state.symptoms = [];
      state.symptomEditForm = {};
      state.unitOptions = [];
      state.scaleOptions = [];
      state.updatedList = false;
      state.itemChanged = false;
      state.updateMode = false;
      state.duplicateItem = false;

      buttonsChecker();
      return { ...state };
    case RESET_CONTRIBUTE_ALERT_STATE:
      state.contributeRedirectionAlert = false;
      state.upc404 = false;
      return { ...state };
    case SET_HHMM_MODE:
      state.hhmmMode = action.value;
      return {
        ...state,
      };
    case ADD_GREY_UPC_ITEM_NAME_FIELD:
      state.symptomEditForm = {
        ...state.symptomEditForm,
        upc: action.payload,
      };
      return { ...state };
    case getStarted(ON_SAVE_PAGE_SYMPTOMEDITFORM):
      return { ...state, isLoading: true, metaText: "" };
    case ON_SAVE_PAGE_SYMPTOMEDITFORM:
      localStorage.removeItem("contDefault");

      if (state.hhmmMode) {
        state.hhmmMode = false;
        state.amountReseter = !state.amountReseter;
      }

      const hasNewTrend = action.data && action.data.trend_alert === true;

      return {
        ...initialState,
        users: state.users,
        saveSuccess: true,               // always show success modal first
        NewTrendFound: !!hasNewTrend,    // when TFI is true, remember Trend Alert is needed
        saveError: { type: null, meta: [] },
        categories: [{ value: "00", label: i18n.t("forum.ALL_PLACEHOLDER") }],
      };

    case getFailed(ON_SAVE_PAGE_SYMPTOMEDITFORM): {
      const { message, meta } = action.error || {};

      let type = null;
      if (message === "identical") {
        type = "identicalRegimen";
      } else if (message === "name already exists") {
        type = "alreadyUsedRecipeName";
      }

      // 🔑 normalize meta to string[]
      const normalizedMeta = Array.isArray(meta)
        ? meta
            .map(m =>
              typeof m === "string"
                ? m
                : (m && m.name) || (m && m.label) || ""
            )
            .filter(Boolean)
        : [];

      return {
        ...state,
        isLoading: false,
        saveError: {
          type,
          meta: normalizedMeta,
        },
      };
    }

    case EDITSYMPTOM_CHANGER_SEARCHFORM:
      var newForm = {};
      if (state.searchForm.chenger) {
        newForm = { ...state.searchForm, [action.name]: action.val };
        delete newForm.chenger;
      } else {
        newForm = {
          ...state.searchForm,
          [action.name]: action.val,
          chenger: true,
        };
      }
      state.searchForm = newForm;
      state.updateMode = false;
      buttonsChecker();
      return { ...state };
    case getStarted(SYMPTOM_EXPORT):
      return { ...state, isLoading: true, exportSuccess: false };
    case getSucceeded(SYMPTOM_EXPORT):
      return {
        ...state,
        isLoading: false,
        exportSuccess: true,
        searchForm: {
          category: state.searchForm.category,
          start: state.searchForm.start,
          exportStart: state.searchForm.exportStart,
          to: state.searchForm.to,
          user: state.searchForm.user,
        },
      };
    case getStarted(EDITSYMPTOM_BODYMAP_RETURN):
      return { ...state, isLoading: true };
    case getSucceeded(EDITSYMPTOM_BODYMAP_RETURN):
      let BodyState = JSON.parse(localStorage.getItem("editPageState"));
      state = BodyState.state;
      state.searchForm.start = moment(BodyState.state.searchForm.start);
      state.searchForm.exportStart = moment(BodyState.state.searchForm.exportStart);
      state.symptomEditForm.time = moment(
        BodyState.state.symptomEditForm.time
      );
      state.amountReseter = !state.amountReseter;
      state.amounNewValue = BodyState.state.symptomEditForm.scale
        ? BodyState.state.symptomEditForm.scale.toString()
        : "";
      buttonsChecker();
      return { ...state };
    case getEnded(EDITSYMPTOM_BODYMAP_RETURN):
      localStorage.removeItem("bodyreturn");
      localStorage.removeItem("bodyMapSymptom");
      localStorage.removeItem("editPageState");
      return { ...state, isLoading: false };
    case getSucceeded(EDITSYMPTOM_BODYMAP_START):
      localStorage.setItem("editPageState", JSON.stringify({ state }));
      return { ...state };
    case EDITSYMPTOM_EXPORT_DATE_CHANGED:
      state.searchForm.exportStart = action.val;
      state.amountReseter = !state.amountReseter;
      return {
        ...state,
        isLoading: false,
      };
    case getStarted(EDIT_PAGE_BARCODE_READ):
      state.itemInVerAutofill = false;
      state.partialResult = [];
      buttonsChecker();
      return {
        ...state,
        isLoading: true,
        upc404: false,
        barcodeCategory: false,
        barcodeRead: false,
        itemInVerAutofill: false,
        amountReseter: !state.amountReseter,
        incorrectBarcodeCategory: false,
        contributeRedirectionAlert: false,
      };
      case getSucceeded(EDIT_PAGE_BARCODE_READ): {
        // Base new state
        let newState = {
          ...state,
          isLoading: false,
          barcodeRead: true,
          amountReseter: !state.amountReseter,
          amounNewValue: "",
          kitdata: [],
          unitOptions: [],
        };

        // Initialize symptom form
        const prevForm = state.symptomEditForm;
        let newForm = {
          ...prevForm,
          name: "",
          sName: "",
          scale: "",
          symptom: "",
          kitdata: {},
          comment: prevForm.comment,
          category: prevForm.category,
          time: prevForm.time || moment(),
          users: prevForm.users,
          unit: "",
        };

        // Get Ingredient information for uploaded barcode
        const getIngredientsStr = (obj) => {
          const s = obj && (obj.ingredients || obj.ingredients_text);
          return s != null ? String(s) : "";
        };

        // Utility to update symptom form, using getItemUnitsList
        const updateSymptomForm = (data, forcedCategory) => {
          const cat = forcedCategory || data.category;
          const ingredientsStr = getIngredientsStr(data);
          let form = {
            ...newForm,
            name: data.name || data.recipe || data.title,
            sName: data.name || data.recipe || data.title,
            recipe_full: data.title,
            recipes: data.name || data.title,
            recipe: data.name || data.title,
            full_name: data.title,
            fullname: data.fullname || data.title,
            displayname: data.name || data.recipe || data.title,
            upc: !is_ref && data.upc,
            scale: "",
            symptom: data._id,
            _id: state.symptomEditForm._id,
            category: cat,
            ingredients_text: ingredientsStr,
          };
          if (data.unitid) form.unit = data.unitid;

          // Determine category-specific unit list
          let listUnits = [];
          if (cat == "02") listUnits = FOOD_UNITS();
          else if (cat == "04") listUnits = PCP_UNITS();
          else if (cat == "05") listUnits = DRUG_UNITS();
          else if (cat == "06") listUnits = SUP_UNITS();

          // Use helper to get measurementOptions and main unit
          const [measurementOptions, mainUnitId] = getItemUnitsList(data.units, listUnits);
          form.unitList = data.units;
          form.units = data.units;
          form.unit = data.unitid ? data.unitid : mainUnitId;
          // Assign results back
          newState.unitOptions = measurementOptions;
          newForm = form;
        };

        // // Extract barcode data
        // const {
        //   category,
        //   is_ref,
        //   is_own,
        //   is_history,
        //   upc,
        //   _id,
        //   number_of_contribute,
        //   show_prompt,
        //   units: itemUnits,
        // } = action.data;


      const {
        category,
        is_ref,
        is_own,
        is_history,
        upc,
        number_of_contribute,
        show_prompt,
      } = action.data;


      // -------- Non-RefDB ITEM --------
      if (!is_ref) {
        // -------- Item in Verification/Incorrect Category/Incompatible Category --------
        if (show_prompt && number_of_contribute >= 4) {
          // -------- history = false --------
          if (!is_history) {
            if (is_own && category !== prevForm.category) {
              // own → incorrect category first
              newState = { 
                ...newState, 
                incorrectBarcodeCategory: true, 
                itemData: action.data, 
                showVerificationPrompt: true, // flag to trigger Item in Verification upon positive action
              };
            } else {
              newState = { ...newState, itemInVerAutofill: true, itemData: action.data };
            }
          }

          // -------- history = true --------
          else {
            if (category !== prevForm.category) {
              updateSymptomForm(action.data);
            } else {
              newState = { ...newState, itemInVerAutofill: true, itemData: action.data };            
            }
          }
        }



        // -------- Incorrect Category/Incompatible Category --------
        else if (number_of_contribute >= 4) {
          // -------- history = false --------
          if (!is_history) {
            if (is_own && category !== prevForm.category) {
              newState = { ...newState, incorrectBarcodeCategory: true, itemData: action.data };
            } else {
              updateSymptomForm(action.data, prevForm.category);
            }
          }

          // -------- history = true --------
          else {
            if (category !== prevForm.category) {
              updateSymptomForm(action.data);
            } else {
              updateSymptomForm(action.data);
            }
          }
        }

        // -------- Product not in 12u12 DB/Incorrect Category/Incompatible Category --------
        else if (number_of_contribute < 4) {
          // -------- history = false --------
          if (!is_history) {
            if (!is_own) {
              newState = {
                ...newState,
                upc404Value: action.data.upc,
                category404Value: action.val,
                upc404: true,
                contributeRedirectionAlert: true,
                listings: Object.entries(i18n.t("BARCODE.UPC404_ERROR_TEXT.LISTING", { returnObjects: true }))
                  .map(([key, val]) => ({ key, value: val })),
              };
            } else if (category !== prevForm.category) {
              newState = { ...newState, incorrectBarcodeCategory: true, itemData: action.data };
            } else {
              updateSymptomForm(action.data);
            }
          }

          // -------- history = true --------
          else {
            if (category !== prevForm.category) {
              updateSymptomForm(action.data);
            } else {
              updateSymptomForm(action.data);
            }
          }
        }
      } 
      
      // -------- RefDB ITEM --------
      else {
        if (category !== prevForm.category) {
          updateSymptomForm(action.data);
        } else {
          updateSymptomForm({ ...action.data, upc: "" });
          state.barcodeRead = true;
        }
      }



        // // Handle conditions
        // if (number_of_contribute < 4 && !is_ref && !is_own && !is_history) {
        //   newState = {
        //     ...newState,
        //     upc404Value: action.data.upc,
        //     category404Value: action.val,
        //     upc404: true,
        //     contributeRedirectionAlert: true,
        //     listings: Object.entries(i18n.t("BARCODE.UPC404_ERROR_TEXT.LISTING", { returnObjects: true }))
        //       .map(([key, val]) => ({ key, value: val })),
        //   };
        // } else if (
        //   number_of_contribute >= 4 &&
        //   !is_ref &&
        //   !is_own &&
        //   !is_history &&
        //   show_prompt
        // ) {
        //   newState = { ...newState, itemInVerAutofill: true, itemData: action.data };
        // } else if (
        //   number_of_contribute >= 4 &&
        //   !is_ref &&
        //   !is_own &&
        //   !is_history &&
        //   !show_prompt
        // ) {
        //   updateSymptomForm(action.data, prevForm.category);
        // } else if (
        //   action.data.category === prevForm.category &&
        //   number_of_contribute >= 4 &&
        //   !is_ref &&
        //   show_prompt
        // ) {
        //   newState = { ...newState, itemInVerAutofill: true, itemData: action.data };
        // } else if (category === prevForm.category) {
        //   if (is_ref) {
        //     updateSymptomForm({ ...action.data, upc: "" });
        //     newState.barcodeRead = true;
        //   } else if (is_own && !show_prompt) {
        //     updateSymptomForm(action.data);
        //   } else if (!is_ref && is_history) {
        //     updateSymptomForm(action.data);
        //   } else if (number_of_contribute >= 4 && show_prompt) {
        //     newState = { ...newState, itemInVerAutofill: true, itemData: action.data };
        //   } else if (number_of_contribute >= 4 && !show_prompt) {
        //     updateSymptomForm(action.data);
        //   }
        // } else {
        //   if (is_ref ||
        //     (!is_ref && !is_own && !is_history && number_of_contribute >= 4 && !show_prompt) ||
        //     (!is_ref && (number_of_contribute < 4 || is_history) && !show_prompt)
        //   ) {
        //     updateSymptomForm(action.data);
        //   } else if (is_own && !is_history) {
        //     newState = { ...newState, incorrectBarcodeCategory: true, itemData: action.data };
        //   }
        // }

        newState.symptomEditForm = newForm;
        newState.barcodeScanned = true;
        buttonsChecker();

        return newState;
      }
    case getEnded(EDIT_PAGE_BARCODE_READ):
      buttonsChecker();
      return {
        ...state,
        isLoading: false,
        barcodeRead: true,
      };
    case getFailed(EDIT_PAGE_BARCODE_READ):
      state.upc404Value = action.upc;
      state.category404Value = action.val;
      state.contributeRedirectionAlert = true;
      let listingObject = i18n.t("BARCODE.UPC404_ERROR_TEXT.LISTING", {
        returnObjects: true,
      });
      state.listings = Object.entries(listingObject).map(([key, value]) => ({
        key,
        value,
      }));
      buttonsChecker();
      return { ...state, isLoading: false, upc404: true };
    case getStarted(EDIT_PAGE_BARCODE_READ_IMG):
      state.itemInVerAutofill = false;
      return { ...state, barcodeFailed: false, isLoading: true };
    case getSucceeded(EDIT_PAGE_BARCODE_READ_IMG):
      return { ...state, isLoading: false };
    case getFailed(EDIT_PAGE_BARCODE_READ_IMG):
      return { ...state, barcodeFailed: true, isLoading: false };

    case getSucceeded(PARTIAL_RESULT_FOUND):
      let getResult = action.partialSearch;
      return {
        ...state,
        partialResult: getResult,
      };
    case getFailed(PARTIAL_RESULT_FOUND):
      return {
        ...state,
        barcodeValue: action.upc,
        addCustomAlert: true,
      };
    case CLEAR_EDIT_SYMPTOMS:
      localStorage.removeItem("contDefault");
      localStorage.removeItem("unContributed");

      if (state.hhmmMode) {
        state.hhmmMode = false;
        state.amountReseter = !state.amountReseter;
      }

      return {
        ...state,
        saveSuccess: false,
        NewTrendFound: false,
        saveError: { type: null, meta: [] },
        exportSuccess: false,
        identicalRegimen: false,
      };
    case ON_CHANGE_ALERT_STATUS:
      return {
        ...state,
        addCustomAlert: !!action.data.addCustomAlert,
        ...action.data,
      };

    case DISMISS_EDIT_SAVE_SUCCESS:
      return { ...state, saveSuccess: false }; // keep NewTrendFound as-is

    case RESET_MODAL:
      state.searchForm.toExport = "";
      return {
        ...state,
        exportSuccess: false,
      };


    default:
      return state;
  }
}

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/editSymptomReducer.js